import * as React from 'react';

// tslint:disable:max-line-length
export const PlaygroundIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero" transform="translate(1)">
      <circle cx="7" cy="2" r="2" />
      <path d="M13.895 3.554a1 1 0 0 0-1.341-.448L8.76 5H1a1 1 0 0 0 0 2h2.999v3.764l-1.895 3.788a1 1 0 0 0 1.79.894L5.616 12h2.381v3a1 1 0 1 0 2 0V6.617l3.446-1.723a1 1 0 0 0 .452-1.341z" />
    </g>
  </svg>
);
